<!--
Image carousel from https://ssense.github.io/vue-carousel/
Lazy Load from https://www.npmjs.com/package/vue-lazyload
-->

<template>
	<!-- <div v-if="images[0] === ''" class="ImageSlider">
		<Carousel
			:perPage="1"
			:paginationSize="6"
			:paginationPadding="3"
			paginationColor="#EEEEEE"
			paginationActiveColor="#EEEEEE"
			:navigationEnabled="true"
		>
			<Slide v-bind:key="placeholderImage">
				<div
					class="imageSlider__background-image"
					v-lazy:background-image="placeholderImage"
				></div>
				<div class="imageSlider__loader">
					<Loading />
				</div>
			</Slide>
		</Carousel>
	</div> -->
	<div class="ImageSlider">
		<Carousel
			:perPage="1"
			:paginationSize="6"
			:paginationPadding="3"
			paginationColor="#EEEEEE"
			paginationActiveColor="#EEEEEE"
			:navigationEnabled="true"
		>
			<div class="imageSlider__loader" v-if="loading">
				<PageLoading :white="true" />
			</div>

			<Slide v-if="!images.length && !loading">
				<div class="imageSlider__wrapper">
					<div
						class="imageSlider__background-image"
						v-lazy:background-image="placeholderImage"
					></div>
					<img class="imageSlider__image" :src="placeholderImage" />
				</div>
			</Slide>

			<Slide v-else v-for="url in images" v-bind:key="url">
				<div class="imageSlider__wrapper">
					<div
						class="imageSlider__background-image"
						v-lazy:background-image="url"
					></div>
					<img class="imageSlider__image" :src="url" />
				</div>
			</Slide>
		</Carousel>
	</div>
</template>

<script>
import Vue from 'vue'
import { Carousel, Slide } from 'vue-carousel'
import VueLazyload from 'vue-lazyload'
import PageLoading from '../atoms/PageLoading'

Vue.use(VueLazyload, {
	listenEvents: ['transitionend'],
	preLoad: 1.3,
	error: '',
	loading: '',
	attempt: 1
})

export default {
	name: 'ImageSlider',
	components: {
		Carousel,
		PageLoading,
		Slide
	},
	props: {
		images: {
			type: Array,
			default: () => [
				'https://r360-api.klappen.se/images/klappen_boende_fallback.jpg',
				'https://r360-api.klappen.se/images/klappen_boende_fallback.jpg',
				'https://r360-api.klappen.se/images/klappen_boende_fallback.jpg',
				'https://r360-api.klappen.se/images/klappen_boende_fallback.jpg'
			]
		},
		placeholderImage: {
			type: String,
			default: 'https://r360-api.klappen.se/images/klappen_boende_fallback.jpg'
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	methods: {}
}
</script>

<style lang="scss">
.ImageSlider {
	position: relative;
	//Old
	//background: $colorPrimary8;
	background-color: $colorPrimary4;
	height: 100%;

	.imageSlider__loader {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 90;

		svg {
			fill: $colorGrey2;
			width: 70px;
			&:focus {
				outline: none;
			}
		}
	}

	.imageSlider__wrapper {
		z-index: 100;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
	.imageSlider__background-image {
		filter: blur(20px);
		opacity: 0.75;
		z-index: 100;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;
	}

	.imageSlider__image {
		height: 100%;
		z-index: 200;
		position: relative;
	}

	.VueCarousel,
	.VueCarousel-wrapper,
	.VueCarousel-inner {
		height: 100% !important;
		position: relative;
	}

	.VueCarousel-slide {
		position: relative;
		color: #fff;
		font-size: 24px;
		text-align: center;
		position: relative;
	}

	.VueCarousel-dot {
		&:last-child {
			width: 4px !important;
			height: 4px !important;
		}
		&:first-child {
			width: 4px !important;
			height: 4px !important;
		}
		&:focus {
			outline: none;
			background-color: $colorGrey1 !important;
		}
		&:hover {
			background-color: $colorGrey1 !important;
		}
	}
	.VueCarousel-dot-container {
		display: flex;
		justify-content: center;
		align-items: center;

		.VueCarousel-dot--active {
			width: 8px !important;
			height: 8px !important;
		}
	}

	.VueCarousel-pagination {
		position: absolute;
		bottom: 40px;
		@include for-tablet-portrait-up {
			bottom: 20px;
		}
	}

	.VueCarousel-navigation-button {
		z-index: 50;
	}

	.VueCarousel-navigation-prev,
	.VueCarousel-navigation-next {
		transform: translateY(-50%) translateX(0%) !important;
		font-size: 0;
		width: 60px;
		height: 60px;
		&:focus,
		&:active,
		&:hover {
			outline: none !important;
		}
	}

	.VueCarousel-navigation-prev {
		//margin-left: 15px;
		background: url('../../assets/icons/arrow-left-white.svg') no-repeat;
		background-color: rgba(42, 62, 97, 0.25) !important;
		background-position: 23px 22px;
	}

	.VueCarousel-navigation-next {
		//margin-right: 15px;
		background: url('../../assets/icons/arrow-right-white.svg') no-repeat;
		background-color: rgba(42, 62, 97, 0.25) !important;
		background-position: 23px 22px;
	}

	.label {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}
</style>
